export const openTabAndPrintContent = ({ html, css, closeModalFunction = undefined, popup = false }) => {
  const windowFeatures = {
    popup: popup,
  };

  const windowForPrint = window.open("", "_target", windowFeatures);
  const outputHtml = `
      <html>
        <head>
          <title>${window.document.title}</title>
          <style type="text/css">${css}</style>
        </head>
        <body>
          ${html}
        </body>
      </html>
    `;

  windowForPrint.document.write(outputHtml);

  setTimeout(() => {
    windowForPrint.document.close();
    windowForPrint.focus();
    windowForPrint.print();

    if (closeModalFunction) {
      closeModalFunction();
    }
  }, 500);
};
